'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/empowher-fireside.webp',
  '/images/event-highlights/empowher-ai-speakers-panel.webp',
  '/images/event-highlights/empowher-ai-speakers-speaking.webp',
  '/images/event-highlights/award.webp',
  '/images/event-highlights/speakers.webp',
  '/images/event-highlights/shyla-speaker.webp',
  '/images/event-highlights/sitting-on-chair.webp',
    '/images/event-highlights/jeowin-reading.webp',
  // '/images/event-highlights/all-new.webp',
  '/images/event-highlights/discuss.webp',
  '/images/event-highlights/evnet-highlist.webp',
  '/images/event-highlights/people-around.webp',
  // '/images/event-highlights/people.webp',
  '/images/event-highlights/attendess.webp',
];

export default function GallerySection() {
  return (
 <section id='event-highlights' className="w-full max-w-[1440px] mx-auto px-4 pb-[30px] pt-[30px] ">     
  {/* Heading */}
      <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest mb-[6] ">
          Event Highlights
        </h2>

      {/* Gallery Grid */}
      <div className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 mt-[30px]">
        {galleryImages.map((src, index) => (
          <div
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image
              src={src}
              alt={`Gallery ${index + 1}`}
              width={500}
              height={500}
              unoptimized
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}
